export default __webpack_public_path__ + "static/media/Ballroll_00256.30143e37.png";